import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function RecentOrdersIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Recent Orders</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.2601 9.125H10.5101V7.725C10.5101 6.225 11.7101 5 13.2101 5H29.5351C31.0351 5 32.2601 6.225 32.2601 7.725V9.125ZM10.5102 35.0001H18.5102C20.1352 26.8751 26.7352 20.5501 34.9852 19.3251V13.8251C34.9852 12.0001 33.7602 10.5251 32.2602 10.5251H10.5102C9.01016 10.5251 7.78516 12.0001 7.78516 13.8251V31.7001C7.78516 33.5251 9.01016 35.0001 10.5102 35.0001ZM21.8601 38.9C21.8601 30.025 29.0601 22.825 37.9351 22.825C46.8101 22.825 54.0101 30.025 54.0101 38.9C54.0101 47.775 46.8101 54.975 37.9351 54.975C33.4851 54.975 29.4851 53.15 26.5851 50.25L29.1101 47.725C31.3601 50 34.4851 51.4 37.9351 51.4C44.8351 51.4 50.4351 45.8 50.4351 38.9C50.4351 32 44.8351 26.4 37.9351 26.4C31.0351 26.4 25.4351 32 25.4351 38.9H30.8101L23.5851 46.1L23.4601 45.85L16.5101 38.9H21.8601ZM36.1351 40.7V31.775V31.75H38.8101V39.35L45.0601 43.075L43.7851 45.225L36.1351 40.7Z"
        />
      </g>
    </SvgIcon>
  );
}

export default RecentOrdersIcon;
